<template>
  <div>
    <back />
    <div class="det">
      <div class="top">
        <div class="title">订单信息：</div>
        <el-form :model="ruleForm" ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <el-row>
            <div style="display: flex;justify-content: space-between;">
              <el-col :span="5">
                <el-form-item label="订单编号:">
                  <div> {{ ruleForm.orderCode }}</div>
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-form-item label="订单状态:">
                  <div v-if="ruleForm.orderStatus == 0" style="color: red;">待支付</div>
                  <div v-if="ruleForm.orderStatus == 1">已支付</div>
                  <div v-if="ruleForm.orderStatus == 2">已完成</div>
                  <div v-if="ruleForm.orderStatus == 3">已取消</div>
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-form-item label="订单金额:">
                  <div>{{ ruleForm.orderAmount }} 元</div>
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-form-item label="优惠金额:">
                  <div>{{ ruleForm.discountAmount }} 元</div>
                </el-form-item>
              </el-col>
            </div>
          </el-row>
          <el-row>
            <div style="display: flex;justify-content: space-between;">
              <el-col :span="5">
                <el-form-item label="支付金额:">
                  <div>{{ ruleForm.payAmount }} 元</div>
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-form-item label="下单时间:">
                  <div>{{ ruleForm.orderTime }}</div>
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-form-item label="付款时间:" v-if="ruleForm.orderStatus == 1 || ruleForm.orderStatus == 2">
                  <div>{{ ruleForm.paymentTime || '--' }}</div>
                </el-form-item>
                <el-form-item label="取消时间:" v-if="ruleForm.orderStatus == 3">
                  <div>{{ ruleForm.cancelTime }}</div>
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-form-item label="完成时间:" v-if="ruleForm.orderStatus == 2">
                  <div>{{ ruleForm.checkTime }}</div>
                </el-form-item>
              </el-col>
            </div>
          </el-row>
        </el-form>
      </div>
      <!-- 用户信息 -->
      <div class="top">
        <div class="title">用户信息：</div>
        <el-form :model="ruleForm" ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <el-row>
            <div style="display: flex;justify-content: space-between;">
              <el-col :span="5">
                <el-form-item label="用户名称：">
                  <div>{{ ruleForm.mallUser?.nickName || '--' }}</div>
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-form-item label="联系电话：">
                  <div>{{ ruleForm.mallUser?.phoneNum || '--' }}</div>
                </el-form-item>
              </el-col>
              <el-col :span="5">
              </el-col>
              <el-col :span="5">
              </el-col>
            </div>
          </el-row>
        </el-form>
      </div>
      <!-- 课程信息 -->
      <div class="top">
        <div class="title">项目信息：</div>
        <div class="g_table ">
          <el-table :data="tableData" style="width: 100%">
            <el-table-column type="expand">
              <template slot-scope="scope">
                <el-form label-position="right" inline class="demo-table-expand">
                  <el-row>
                    <el-form-item label="服务部位：" label-width="130px">
                      <span>{{ scope.row.serviceLocation }}</span>
                    </el-form-item>
                  </el-row>
                  <el-row>
                    <el-form-item label="服务内容：" label-width="130px">
                      <el-image v-if="scope.row.processPic" style="width: 150px; height: 150px"
                        :src="scope.row.processPic" :preview-src-list="[scope.row.processPic]" fit="cover">
                      </el-image>
                      <div v-else>--</div>
                    </el-form-item>
                  </el-row>
                </el-form>
              </template>
            </el-table-column>
            <el-table-column label="序号" width="80" align="center">
              <template slot-scope="scope">
                {{ scope.$index + 1 }}
              </template>
            </el-table-column>
            <el-table-column label="项目名称" prop="projectName">
            </el-table-column>
            <el-table-column label="项目分类" prop="categoryName">
            </el-table-column>
            <el-table-column label="时长(分钟)" prop="durationMinute">
            </el-table-column>
            <el-table-column label="总次数" prop="projectCount">
            </el-table-column>
            <el-table-column label="剩余次数" prop="surplusCount">
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
export default {
  data() {
    return {
      ruleForm: {},//订单信息
      tableData: []//服务内容
    };
  },
  created() {
    this.getRequest()
  },
  methods: {
    // 修改请求当前信息
    getRequest() {
      this.loading = true;
      this.$axios.get(this.$api.projectOrderInfo, {
        params: {
          projectOrderId: this.$route.query.projectOrderId,//订单id
        }
      }).then((res) => {
        const { code, result } = res
        if (code == 100) {
          this.ruleForm = result//订单信息
          this.tableData = result.projectInfoVoList || []//服务内容


        }
      }).catch((err) => {
        this.$message.error(err.desc)
        this.loading = false;
      })

    },

  }
}
</script>

<style scoped lang='scss'>
.det {
  padding: 10px 0 0 10px;

  .title {
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: bold;
    font-size: 18px;
    color: #1A1A1A;
    text-align: left;
    margin-bottom: 20px;
  }

  .top {
    border-bottom: 1px solid #E2E2E2;
    margin-bottom: 30px;
    padding-bottom: 20px;

    .el-form-item {
      margin-bottom: 0px;
    }
  }

  .demo-table-expand {
    font-size: 0;
  }

  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }

  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
  }
}
</style>